

  // KES: tag lamp lines with the product-template arm the fitting was added from, so the
  // Shoplift PDP trust-band test can split lamp attach by arm. Reads the hidden input the
  // buy-buttons block emits; adds nothing when it is absent.
  function kesArmTag(items) {
    var el = document.querySelector('input[name="properties[_kes_pdp]"]');
    if (!el || !el.value) return items;
    return items.map(function (it) {
      var out = {}; for (var k in it) out[k] = it[k];
      out.properties = out.properties || {}; out.properties._kes_pdp = el.value; return out;
    });
  }
/**
 * Behaviour for the three KES fitting notices, all quantity-aware:
 *   - snippets/kes-lamps-required.liquid   (PDP, lamps)
 *   - snippets/kes-driver-required.liquid  (PDP, Astro low-voltage drivers)
 *   - snippets/kes-cart-lamp-gap.liquid    (cart drawer and /cart, lamps)
 *
 * WHY THIS LIVES IN A GLOBAL ASSET AND NOT INLINE IN THE SNIPPETS.
 *
 * Both snippets render conditionally, and the cart one renders inside cart-summary,
 * which the theme only outputs when the cart is NOT empty. So on the ordinary customer
 * path - empty basket, add a fitting, drawer opens - the snippet markup arrives through
 * the Section Rendering API, and an injected <script> never executes. The handler was
 * therefore never bound and the button was inert. Loading from the layout means the
 * listeners exist before any of this markup does.
 *
 * Everything here is delegated on document and re-reads the DOM at call time, so it
 * survives morph() replacing the markup wholesale (cart drawer updates, and combined
 * listing variant switches, which morph the whole of <main>).
 */
(function () {
  if (window.__kesLampBlocks) return;
  window.__kesLampBlocks = true;

  var PDP = '[data-kes-lamp]';
  var DRV = '[data-kes-drv]';

  function money(p) {
    return '£' + (p / 100).toFixed(2);
  }

  function num(v, fallback) {
    var n = parseInt(v, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  /**
   * Write text only when it has actually changed. Shared by both PDP renders.
   *
   * WHY THIS IS NOT A MICRO-OPTIMISATION. Setting textContent replaces the text NODE, and
   * WebKit will not fire `click` when the node under the pointer is replaced between
   * mousedown and mouseup. Both blocks re-render on every cart and section update, so a
   * customer whose tap coincides with a re-render gets mousedown, mouseup and no click:
   * the button visibly does nothing. Measured 7 Sep 2026 with Playwright WebKit at 1440,
   * ten real taps on 'Add driver to basket' against each of two preview themes, one with
   * this guard and one from untouched master: 10 of 10 adds landed with it, 5 of 10
   * without, and every failure logged exactly mousedown, mouseup and no click. KES is
   * about half iPhone traffic, so this is a real lost basket, not a test artefact.
   * Re-measured the same way on the LAMP block, 8 Sep 2026. Reproduce with _wkloop.js in
   * /KES Theme Checks/.
   *
   * The guard is on the WRITE, not on the render, so nothing about either block's
   * behaviour changes: they still recompute on every event, they just stop churning
   * identical text through the DOM under the customer's finger.
   */
  function setText(el, s) {
    if (el && el.textContent !== s) el.textContent = s;
  }

  /* ------------------------------------------------------------------ PDP */

  /**
   * The fitting quantity the customer has actually selected. Same selector the theme
   * uses. Scoped to a cart/add form, skipping our OWN form - which also posts to
   * /cart/add and carries a hidden quantity, so a naive querySelector could read our
   * value back and lock the count at its starting number.
   */
  function qtyInput(root) {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      // Skip OUR OWN forms, all of them. Each posts to /cart/add and carries a hidden
      // quantity, so a naive read could pick one up and lock the count at its own number.
      // Checking every notice, not just this block's root, because the driver and lamp
      // notices can in principle sit on the same page.
      if (forms[i].closest('.kes-lamp, .kes-drv, .kes-gap')) continue;
      if (root && root.contains(forms[i])) continue;
      var q = forms[i].querySelector('[name="quantity"]');
      if (q) return q;
    }
    return null;
  }

  function fittings(root) {
    var i = qtyInput(root);
    var n = i ? parseInt(i.value, 10) : 1;
    return Number.isFinite(n) && n > 0 ? n : 1;
  }

  /** Same reader, named for use from the driver block. */
  var fittingsFor = fittings;

  /** Cheapest honest split: whole packs first, singles for the remainder. */
  function plan(cfg, needed) {
    var packs = 0;
    var singles = needed;
    if (cfg.packId && cfg.packSize > 0 && needed >= cfg.packSize) {
      packs = Math.floor(needed / cfg.packSize);
      singles = needed % cfg.packSize;
    }
    var gross = packs * cfg.packPrice + singles * cfg.singlePrice;
    // Shopify's discount Function reduces PER UNIT, truncated to whole pence, then
    // multiplies by quantity. Percentage-of-line-total is out by pennies on multiples:
    // 15 candles is £12.90 off (floor(869 x 10%) = 86p each), not £13.03. Match it
    // exactly or the button quotes a price the basket will not charge.
    var unitOff = function (p) {
      return Math.floor((p * cfg.discountPct) / 100);
    };
    var off = cfg.discountPct > 0 ? packs * unitOff(cfg.packPrice) + singles * unitOff(cfg.singlePrice) : 0;
    return { packs: packs, singles: singles, needed: needed, gross: gross, net: gross - off, off: off };
  }

  function config(root) {
    return {
      perFitting: num(root.dataset.perFitting, 1) || 1,
      discountPct: num(root.dataset.discount, 0),
      singleId: root.dataset.singleId,
      singlePrice: num(root.dataset.singlePrice, 0),
      packId: root.dataset.packId || null,
      packPrice: num(root.dataset.packPrice, 0),
      packSize: num(root.dataset.packSize, 0)
    };
  }

  function currentPlan(root) {
    var cfg = config(root);
    return plan(cfg, cfg.perFitting * fittings(root));
  }

  /**
   * @param {boolean} resetState - clear the success/disabled state. True when the customer
   *   changed the quantity, since that means they want a different number. False when we
   *   are only re-rendering because the DOM moved underneath us, which must not wipe an
   *   'Added' confirmation the customer just earned.
   */
  function renderPdp(resetState) {
    var root = document.querySelector(PDP);
    if (!root) return;

    var cfg = config(root);
    var n = fittings(root);
    var needed = cfg.perFitting * n;
    var p = plan(cfg, needed);

    var elNeed = root.querySelector('[data-kes-lamp-need]');
    var elBand = root.querySelector('[data-kes-lamp-band]');
    var elNow = root.querySelector('[data-kes-lamp-now]');
    var elWas = root.querySelector('[data-kes-lamp-was]');
    var elSave = root.querySelector('[data-kes-lamp-save]');
    var elSaveBar = root.querySelector('[data-kes-lamp-savebar]');
    var elEach = root.querySelector('[data-kes-lamp-each]');
    var elBtn = root.querySelector('[data-kes-lamp-add]');
    var elBtnT = root.querySelector('[data-kes-lamp-btntext]');
    var elNote = root.querySelector('[data-kes-lamp-note]');
    var elQty = root.querySelector('[data-kes-lamp-qty]');
    if (!elNow || !elBtn || !elBtnT) return;

    // A morphed-in root is a fresh element with no memory, so treat it as a change.
    var changed = root.dataset.kesLampNeeded !== String(needed);
    root.dataset.kesLampNeeded = String(needed);

    if (resetState || changed) {
      elBtn.disabled = false;
      if (elNote) {
        elNote.hidden = true;
        elNote.removeAttribute('data-err');
      }
    }

    setText(elBand, needed > 1 ? 'Lamps not included' : 'Lamp not included');

    if (elNeed) {
      // innerHTML replaces child nodes exactly as textContent does, so it needs the same
      // guard as setText for the same reason. This span carries <b> tags, hence not setText.
      var needHtml =
        n > 1 ? 'You have selected <b>' + n + '</b>, so you need <b>' + needed + '</b>.' : '';
      if (elNeed.innerHTML !== needHtml) elNeed.innerHTML = needHtml;
    }

    setText(elNow, money(p.net));
    if (elWas) {
      var discounted = cfg.discountPct > 0 && p.gross > p.net;
      setText(elWas, discounted ? money(p.gross) : '');
      elWas.hidden = !discounted;
      if (elSave) {
        setText(elSave, discounted ? 'You save ' + money(p.gross - p.net) : '');
        elSave.hidden = !discounted;
      }
      // The span above is only the number. Hiding it on its own would leave the bar
      // it sits in showing a tick and 'applied with this fitting' with nothing applied.
      if (elSaveBar) elSaveBar.hidden = !discounted;
    }

    // The per-lamp price. On a five-light chandelier this is the difference between
    // asking for £43.45 and asking for £8.69 a lamp, five times over. With a pack in the
    // split the two unit prices differ, so quote what it works out at across the lot.
    if (elEach) {
      var each = '';
      if (needed >= 2 && p.packs) {
        var parts = [p.packs + ' x ' + cfg.packSize + ' pack'];
        if (p.singles) parts.push(p.singles + (p.singles > 1 ? ' singles' : ' single'));
        each =
          needed + ' lamps needed · ' + parts.join(' + ') + ' · works out at ' +
          money(Math.round(p.net / needed)) + ' a lamp';
      } else if (needed >= 2) {
        each = needed + ' lamps needed · ' + money(p.net / needed) + ' each';
      }
      setText(elEach, each);
    }

    // Do not overwrite a success label with a price the customer has already paid past.
    if (!elBtn.disabled) {
      setText(
        elBtnT,
        needed > 1
          ? 'Add ' + needed + ' lamps to basket · ' + money(p.net)
          : 'Add lamp to basket · ' + money(p.net)
      );
    }

    // Keep the no-JS fallback field meaning one thing only: the total lamps needed, as
    // singles. Not the pack remainder - setting it to p.singles made 13 fittings read '1'.
    if (elQty) elQty.value = needed;
  }

  function pdpItems(root) {
    var cfg = config(root);
    var p = currentPlan(root);
    var out = [];
    if (p.packs) out.push({ id: Number(cfg.packId), quantity: p.packs });
    if (p.singles) out.push({ id: Number(cfg.singleId), quantity: p.singles });
    return out;
  }

  /* --------------------------------------------------------------- driver */

  /**
   * Drivers are not an upsell. A fitting that runs on low voltage does not light without
   * one, so the only thing that matters here is that the customer leaves with the RIGHT
   * NUMBER. The block used to post exactly one whatever the basket held: of the 31 orders
   * since go-live containing a driver-required fitting, 84% bought more than one fitting
   * and 22 went out short. One driver can run several fittings (kes.driver_max_fittings),
   * so the count is a ceiling division, not a multiplication.
   */
  function drvPlan(root) {
    var per = num(root.dataset.perDriver, 1) || 1;
    var price = num(root.dataset.driverPrice, 0);
    var fittings = fittingsFor(root);
    var needed = Math.ceil(fittings / per);
    if (!(needed > 0)) needed = 1;
    return { per: per, price: price, fittings: fittings, needed: needed, cost: price * needed };
  }

  function renderDrv(resetState) {
    var root = document.querySelector(DRV);
    if (!root) return;

    var p = drvPlan(root);
    var elBand = root.querySelector('[data-kes-drv-band]');
    var elNow = root.querySelector('[data-kes-drv-now]');
    var elEach = root.querySelector('[data-kes-drv-each]');
    var elCount = root.querySelector('[data-kes-drv-count]');
    var elBtn = root.querySelector('[data-kes-drv-add]');
    var elBtnT = root.querySelector('[data-kes-drv-btntext]');
    var elNote = root.querySelector('[data-kes-drv-note]');
    var elQty = root.querySelector('[data-kes-drv-qty]');
    if (!elNow) return;

    var changed = root.dataset.kesDrvNeeded !== String(p.needed);
    root.dataset.kesDrvNeeded = String(p.needed);

    if ((resetState || changed) && elBtn) {
      elBtn.disabled = false;
      if (elNote) {
        elNote.hidden = true;
        elNote.removeAttribute('data-err');
      }
    }

    setText(elBand, p.needed > 1 ? 'Drivers not included' : 'Driver not included');

    // The arithmetic lives in the count bar now, not in the explanatory paragraph and not
    // in the per-unit line. It is the one thing this block exists to get right, so it is
    // stated once, in the loudest place, rather than three times quietly.
    setText(
      elCount,
      p.needed > 1
        ? p.needed + ' drivers for ' + p.fittings + ' fittings'
        : p.fittings > 1
          ? '1 driver for ' + p.fittings + ' fittings'
          : '1 driver for this fitting'
    );

    setText(elNow, money(p.cost));
    setText(elEach, p.needed > 1 ? money(p.price) + ' each' : '');

    if (elBtn && elBtnT && !elBtn.disabled) {
      setText(
        elBtnT,
        p.needed > 1
          ? 'Add ' + p.needed + ' drivers to basket · ' + money(p.cost)
          : 'Add driver to basket · ' + money(p.cost)
      );
    }

    // Keep the no-JS fallback field meaning one thing: the number of drivers needed.
    if (elQty) elQty.value = p.needed;
  }

  /* ----------------------------------------------------------------- cart */

  function gapItems(root) {
    try {
      return JSON.parse(root.dataset.items) || [];
    } catch (e) {
      return [];
    }
  }

  /* ------------------------------------------------------------- plumbing */

  /**
   * cart-items-component listens for 'cart:update' and reads event.detail.data.sections.
   * detail.data MUST be an object: on undefined the handler throws a TypeError and the
   * theme's own cart refresh breaks. With no section HTML supplied it re-fetches the
   * section itself, which is exactly what we want - the block recomputes server-side.
   */
  function announceCartChange(source) {
    if (document.querySelector('cart-items-component')) {
      document.dispatchEvent(
        new CustomEvent('cart:update', { bubbles: true, detail: { data: {}, source: source } })
      );
      return true;
    }
    return false;
  }

  /* ------------------------------------------------------------ listeners */

  // PDP: add the lamps. Delegated, so it does not care when the block appeared.
  document.addEventListener('submit', function (ev) {
    var form = ev.target && ev.target.closest && ev.target.closest('.kes-lamp__form');
    if (!form) return;
    var root = form.closest(PDP);
    if (!root) return;

    ev.preventDefault();

    var elBtn = root.querySelector('[data-kes-lamp-add]');
    var elBtnT = root.querySelector('[data-kes-lamp-btntext]');
    var elNote = root.querySelector('[data-kes-lamp-note]');
    var body = pdpItems(root);
    if (!body.length) return;

    if (elBtn) elBtn.disabled = true;
    if (elNote) {
      elNote.hidden = true;
      elNote.removeAttribute('data-err');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: kesArmTag(body) })
    })
      .then(function (r) {
        return r.json().then(function (j) {
          return { ok: r.ok, j: j };
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j && res.j.description ? res.j.description : 'Could not add');
        if (elNote) {
          elNote.textContent = 'Added to your basket.';
          elNote.hidden = false;
        }
        if (elBtnT) elBtnT.textContent = 'Added';
        announceCartChange('kes-lamps');
      })
      .catch(function (e) {
        if (elNote) {
          elNote.textContent = e.message || 'Sorry, that did not work. Please try again.';
          elNote.setAttribute('data-err', '');
          elNote.hidden = false;
        }
        if (elBtn) elBtn.disabled = false;
      });
  });

  // PDP: add the drivers. Delegated, so it does not care when the block appeared.
  document.addEventListener('submit', function (ev) {
    var form = ev.target && ev.target.closest && ev.target.closest('.kes-drv__form');
    if (!form) return;
    var root = form.closest(DRV);
    if (!root) return;

    ev.preventDefault();

    var elBtn = root.querySelector('[data-kes-drv-add]');
    var elBtnT = root.querySelector('[data-kes-drv-btntext]');
    var elNote = root.querySelector('[data-kes-drv-note]');
    var p = drvPlan(root);
    var id = Number(root.dataset.driverId);
    if (!id || !p.needed) return;

    if (elBtn) elBtn.disabled = true;
    if (elNote) {
      elNote.hidden = true;
      elNote.removeAttribute('data-err');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: kesArmTag([{ id: id, quantity: p.needed }]) })
    })
      .then(function (r) {
        return r.json().then(function (j) {
          return { ok: r.ok, j: j };
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j && res.j.description ? res.j.description : 'Could not add');
        if (elNote) {
          elNote.textContent = 'Added to your basket.';
          elNote.hidden = false;
        }
        if (elBtnT) elBtnT.textContent = 'Added';
        announceCartChange('kes-drivers');
      })
      .catch(function (e) {
        if (elNote) {
          elNote.textContent = e.message || 'Sorry, that did not work. Please try again.';
          elNote.setAttribute('data-err', '');
          elNote.hidden = false;
        }
        if (elBtn) elBtn.disabled = false;
      });
  });

  // Cart drawer and /cart: fill the basket's lamp gap.
  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest && ev.target.closest('[data-kes-gap-add]');
    if (!btn) return;
    var root = btn.closest('[data-kes-gap]');
    if (!root) return;

    ev.preventDefault();

    var note = root.querySelector('[data-kes-gap-note]');
    var label = btn.textContent;
    var items = gapItems(root);
    if (!items.length) return;

    btn.disabled = true;
    btn.textContent = 'Adding...';
    if (note) {
      note.hidden = true;
      note.removeAttribute('data-err');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        // With the gap now filled the block re-renders to nothing at all, so there is no
        // state to restore here.
        if (!announceCartChange('kes-gap')) window.location.reload();
      })
      .catch(function () {
        // Restore the real label rather than overwriting it, so the price is not lost.
        btn.disabled = false;
        btn.textContent = label;
        if (note) {
          note.textContent = 'Sorry, that did not work. Please try again.';
          note.setAttribute('data-err', '');
          note.hidden = false;
        }
      });
  });

  // Typing in the quantity box fires native input/change events.
  ['input', 'change'].forEach(function (type) {
    document.addEventListener(type, function (ev) {
      var t = ev.target;
      if (t && t.name === 'quantity') {
        renderPdp(true);
        renderDrv(true);
      }
    });
  });

  // The +/- buttons fire NO native event. quantity-selector-component.updateQuantity()
  // assigns quantityInput.value as a PROPERTY, which never mutates the value attribute,
  // so a MutationObserver on attributes cannot see it either, and then dispatches its own
  // bubbling QuantitySelectorUpdateEvent. Listening for that on document is the only way
  // to catch them. It also covers the blur path, since setQuantity() dispatches the same
  // event. Name comes from ThemeEvents.quantitySelectorUpdate in assets/events.js.
  document.addEventListener('quantity-selector:update', function () {
    renderPdp(true);
    renderDrv(true);
  });

  // Re-render when the DOM moves under us: the buy-buttons block hydrating late, or morph()
  // swapping in a fresh block after a cart update or a combined-listing variant switch.
  var pending = false;
  function scheduleRender() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      renderPdp(false);
      renderDrv(false);
    });
  }

  function start() {
    renderPdp(false);
    renderDrv(false);
    new MutationObserver(scheduleRender).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
